let wc_set_pro_image_of_qty_bundle=(qty_option_section,wc_variant_options)=>{
  let wc_current_variant='';
  wc_session_product_detail.variants.forEach((wc_variant)=>{
    let is_variant_found=true;
    if(wc_variant.options.length==wc_variant_options.length){wc_variant.options.forEach((option,option_index)=>{if(option!=wc_variant_options[option_index]){is_variant_found=false}})}
    is_variant_found ? wc_current_variant=wc_variant:'';
  })
  let wc_current_variant_img_src=wc_current_variant.featured_image.src;
  let wc_custom_image_qty_bun=qty_option_section.querySelector('.wc_qty_bundle_pro_img');
  if(wc_custom_image_qty_bun){wc_custom_image_qty_bun.src=wc_current_variant_img_src}else{
     let wc_custom_image_section=`<div class="wc_qty_bundle_img_containor">`;
     wc_custom_image_section+= `<img src="${wc_current_variant_img_src}" class="wc_qty_bundle_pro_img">`;
     wc_custom_image_section+= `</div>`;
     qty_option_section.querySelector('.RB_QL_Variant_Content').insertAdjacentHTML('afterbegin', wc_custom_image_section);
  }
}


document.body.addEventListener('change',(event)=>{
  let change_event_target_element=event.target;
  console.log("target element",change_event_target_element)
  if(change_event_target_element.classList.contains('RB_Quantity_List_Input')){
      let qty_option_section=change_event_target_element.closest('.RB_Quantity_List')
      let wc_variant_options=[];
      let wc_select_elements=qty_option_section.querySelectorAll('.RB_Row:first-child .RB_PC_Selector');
      wc_select_elements.forEach((wc_select_option)=>{
        wc_variant_options.push(wc_select_option.options[wc_select_option.selectedIndex].value);
      })
      let wc_selected_swatches=qty_option_section.querySelectorAll('.RB_Row:first-child .RB_PC_Swatch_Field_Btn[checked]');
      if(wc_selected_swatches){wc_selected_swatches.forEach((checked_swatch)=>{wc_variant_options.push(checked_swatch.value)})}
      if(wc_variant_options.length){
       wc_set_pro_image_of_qty_bundle(qty_option_section,wc_variant_options);
      }
  }
  if(change_event_target_element.classList.contains('RB_PC_Swatch_Field_Btn') || change_event_target_element.classList.contains('RB_PC_Selector')){
      let qty_option_section=change_event_target_element.closest('.RB_Quantity_List')
      let wc_variant_options=[];
      let wc_select_elements=change_event_target_element.closest('.RB_Row').querySelectorAll('.RB_PC_Selector');
      wc_select_elements.forEach((wc_select_option)=>{
        wc_variant_options.push(wc_select_option.options[wc_select_option.selectedIndex].value);
      })
      let wc_selected_swatches=change_event_target_element.closest('.RB_Row').querySelectorAll('.RB_PC_Swatch_Field_Btn:checked');
      if(wc_selected_swatches){wc_selected_swatches.forEach((checked_swatch)=>{wc_variant_options.push(checked_swatch.value)})}
      if(wc_variant_options.length){
       wc_set_pro_image_of_qty_bundle(qty_option_section,wc_variant_options);
      }
  }
})
window.wc_session_product_detail='';
let wc_qty_bundle_custom_img_logic=()=>{
  let wc_qty_bun_shortcode=document.querySelector('.rebolt_QtyBundle');
  let wc_pro_id=wc_qty_bun_shortcode.dataset.pid;
  let wc_sesstion_pro_arr=JSON.parse(sessionStorage.getItem('RB_product'));
  let wc_product_detail=wc_sesstion_pro_arr[wc_pro_id];
  if(wc_product_detail){
    wc_session_product_detail=wc_product_detail;
    let qc_qty_bundle_options=document.querySelectorAll('.RB_Quantity_List');
    qc_qty_bundle_options.forEach((qty_option_section)=>{
      let wc_variant_options=[];
      let wc_select_elements=qty_option_section.querySelectorAll('.RB_Row:first-child .RB_PC_Selector');
      wc_select_elements.forEach((wc_select_option)=>{
        wc_variant_options.push(wc_select_option.options[wc_select_option.selectedIndex].value);
      })
      let wc_selected_swatches=qty_option_section.querySelectorAll('.RB_Row:first-child .RB_PC_Swatch_Field_Btn[checked]');
      if(wc_selected_swatches){wc_selected_swatches.forEach((checked_swatch)=>{wc_variant_options.push(checked_swatch.value)})}
      if(wc_variant_options.length){
       wc_set_pro_image_of_qty_bundle(qty_option_section,wc_variant_options);
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if(__st.p=='product'){
    let wc_count=0;
    let wc_set_interval=setInterval(()=>{
      let wc_qty_bun_shortcode=document.querySelector('.RB_Quantity_Wrapper');
      if(wc_qty_bun_shortcode){
        wc_qty_bundle_custom_img_logic();
        clearInterval(wc_set_interval);
      }
      wc_count++;
      (wc_count>10)?clearInterval(wc_set_interval):'';
    },1000)
  }
});
